import { Location as HistoryLocation } from "history";
import React from "react";
import { connect } from "react-redux";
import { Route, RouteProps } from "react-router";
import { push } from "react-router-redux";
import * as redux from "redux";
import { Paths } from "../../constants";
import { AppState } from "../../store";
import { RedirectWithStatus } from "../generic";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    isLoggedIn: (state.auth.data)
        ? state.auth.data.hasUserRecord
        : false,
    url: state.router.location,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    redirectToLogin: (returnUrl: string) => {
        dispatch(push(Paths.Account.Login + returnUrl));
    },
});

type OwnProps = RouteProps & {
};

interface OwnState {
}

interface ConnectedState {
    isLoggedIn: boolean;
    url: HistoryLocation | null;
}

interface ConnectedDispatch {
    redirectToLogin: (returnUrl: string) => void;
}

interface OwnState {
}

class LoginRouteComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {
    public getRedirectUrl(staticContext?: any) {
        let redirectUrl = Paths.Account.Login;

        if (this.props.url) {
            const pathname = this.props.url.pathname;
            const search = this.props.url.search || (staticContext ? (staticContext.search || "") : "");
            const hash = this.props.url.hash || (staticContext ? (staticContext.hash || "") : "");
            const encodedReturnUrl = encodeURIComponent(decodeURIComponent((pathname + "") + (search + "") + (hash + "")));
            redirectUrl += "?returnUrl=" + encodedReturnUrl;
        }

        return redirectUrl;
    }

    public render() {
        const Component = this.props.component;
        const render = this.props.render;
        const rp = { ...this.props, component: undefined, render: undefined };

        return <Route { ...rp } render={(routeProps) => {
            if (!this.props.isLoggedIn) {
                return <RedirectWithStatus to={this.getRedirectUrl(routeProps.staticContext)} />;
            }
            else {
                if (Component)
                    return <Component { ...routeProps } />;
                else if (render)
                    return render(routeProps);
                else
                    return null;
            }

        }} />;

        // if (!this.props.isLoggedIn)
        //     return <RedirectWithStatus to={this.getRedirectUrl()} />;

        // return this.props.children;
    }
}

export const LoginRoute: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(LoginRouteComponent);



// WEBPACK FOOTER //
// ./src/components/access/LoginRoute.tsx